module.exports = __webpack_public_path__ + "img/07.1c7365c7.png";